import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import Home from './component/Home';
import Main from './component/Main';
import ScanPage from './Admin/ScanPage';
import AddEvent from './Admin/AddEvent';
import Addnew from './Admin/Addnew';
import EventDetail from './component/EventDetail';
import Report from './Admin/Report';
import Supervisor from './Admin/Supervisor';
import SuperReports from './Admin/SuperReport';
import SendInvites from './component/SendInvites';
import Dashboard from './component/dashboard';
import './App.css';
import PublicEvents from './component/PublicEvents';
import JoinRequestsReport from './component/JoinRequestsReport';
import TermsAndConditions from './component/TermsAndConditions';
import RefundPolicy from './component/RefundPolicy';
import Shipping from './component/shipping';
import Privacy from './component/privacy';
import ContactUs from './component/contactus';
import MeetingSearch from './component/MeetingSearch';
import AdminSendInvite from './Admin/AdminSendInvite';
import RestrictMeeting from './Admin/RestrictMeeting';
import EventRegistrations from './Admin/EventRegistrations';
import CardPrintComponent from './Admin/CardPrintComponent';

// Login Component (Unused but preserved)
const Login = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState('admin');

  const userId = localStorage.getItem('userId');
  const userRole = localStorage.getItem('role');

  // Redirect if already logged in
  if (userId && userRole) {
    switch (userRole) {
      case 'admin':
        return <Navigate to="/dashboard" replace />;
      case 'supervisor':
        return <Navigate to="/supervisor" replace />;
      case 'superadmin':
        return <Navigate to="/scan" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }
};

// ProtectedRoute Component (Updated)
const ProtectedRoute = ({ element, allowedRole }) => {
  const location = useLocation();
  const userId = localStorage.getItem('userId');
  const role = localStorage.getItem('role');

  if (!userId) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (allowedRole && role !== allowedRole) {
    return <Navigate to="/" replace />;
  }

  return element;
};

// Main App Component
const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/main" element={<Main />} />
        <Route path="/public-events" element={<PublicEvents />} />
        <Route path="/term-condition" element={<TermsAndConditions />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
         <Route path="/card-print" element={<CardPrintComponent />} />
        {/* <Route path="/login" element={<Login />} /> */}

        {/* Supervisor Routes */}
        <Route
          path="/supervisor"
          element={<ProtectedRoute element={<Supervisor />} allowedRole="supervisor" />}
        />
        <Route
          path="/scann"
          element={<ProtectedRoute element={<ScanPage />} allowedRole="supervisor" />}
        />
        <Route
          path="/reports"
          element={<ProtectedRoute element={<Report />} allowedRole="supervisor" />}
        />

        {/* Admin Routes */}
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={<Dashboard />} allowedRole="admin" />}
        />
        <Route
          path="/EventRegistrations"
          element={<ProtectedRoute element={<EventRegistrations />} allowedRole="admin" />}
        />
        <Route
          path="/create-meeting"
          element={<ProtectedRoute element={<EventDetail />} allowedRole="admin" />}
        />
        <Route
          path="/view-meetings"
          element={<ProtectedRoute element={<Addnew />} allowedRole="admin" />}
        />
        <Route
          path="/adminsend"
          element={<ProtectedRoute element={<AdminSendInvite />} allowedRole="admin" />}
        />
         <Route
          path="/restrict-meeting"
          element={<ProtectedRoute element={<RestrictMeeting />} allowedRole="admin" />}
        />
        <Route
          path="/send-invites"
          element={<ProtectedRoute element={<SendInvites />} allowedRole="admin" />}
        />
         <Route
          path="/search-form"
          element={<ProtectedRoute element={<MeetingSearch />} allowedRole="admin" />}
        />

        {/* Superadmin Routes */}
        <Route
          path="/scan"
          element={<ProtectedRoute element={<AddEvent />} allowedRole="superadmin" />}
        />
        <Route
          path="/superReports"
          element={<ProtectedRoute element={<SuperReports />} allowedRole="superadmin" />}
        />
      </Routes>
    </Router>
  );
};

export default App;